/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";

class Reports extends BaseCom {

    componentDidMount() {
        qreq.get('/api/report/list', j => {
            if(j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
        this.applyThemeColors();
    }

    render() {
        return <div className="container-fluid">
            <h1><L>Reports</L></h1>
            <DataTable data={this.state.list || []} columns={[
                { name: 'name', title: 'Report', valueFunc: row => {
                    return <Link to={'/reports/' + row.ident}>{row.name}</Link>;
                } }
            ]} headClassName="--bg-primary" />
        </div>;
    }
}

export default withParamsAndNavigate(Reports);